// extracted by mini-css-extract-plugin
module.exports = {"pageError":"style_pageError__cdUfV","artwork":"style_artwork__baeRB","btn":"style_btn__gVH7O"};